import Stack from '@mui/material/Stack';
import type { FC } from 'react';
import { useTranslations } from '../intl';
import { SidebarItem } from './helper';

const LANGUAGES = ['swiss', 'german', 'english'] as const;

export const HumanLanguages: FC = () => {
  const t = useTranslations('HumanLanguages');
  return (
    <SidebarItem title={t('name')}>
      <Stack sx={{ gap: 1 }}>
        {LANGUAGES.map((lang) => (
          <div key={lang}>{t(lang)}</div>
        ))}
      </Stack>
    </SidebarItem>
  );
};
